import { Button, Col, Row } from 'react-bootstrap';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { BsXCircle } from 'react-icons/bs';
import { setFilters } from '../../../../redux/slices/filters';
import DateFilter from './DateFilter';
import { useCallback, useState } from 'react';
import EventSelector from './EventSelector';
import { useDispatch, useSelector } from 'react-redux';
import ExportReport from '../exportReport';
import useUrlParams from '../../../../hooks/useUrlParams';


const START_DATE_RANGE = {
  selection1: {
    startDate: null,
    endDate: null,
    key: 'selection1'
  }
};

const Filters = ({ events, eventMeta, isLoadingStats }) => {
  const {t} = useTranslation()
  const dispatch = useDispatch()
  const { eventId } = useUrlParams();
  const isFitersActive = useSelector((state) => state.filters.isFitersActive);
  const [showLoader, setShowLoader] = useState(false)
  const handleShowLoader = (isShow) => setShowLoader(isShow)

  const allEventsOption = t('ticketStatistic.allEvents');
  const [selectedOptions, setSelectedOptions] = useState([{ id: null, name: allEventsOption }]);

  const handleInitialEventResolved = useCallback((event) => {
    setSelectedOptions([event]);
  }, []);

  const applyFilters = () => {
    const periodStart = dateRange.selection1.startDate
      ? moment(dateRange.selection1.startDate)
      : null;
    const eventsArray = selectedOptions
      .map((option) => option.id)
      .filter((id) => id !== null);
    const filterOptions = {
      periodStart,
      periodEnd: dateRange.selection1.endDate
        ? moment(dateRange.selection1.endDate).endOf('D').toDate()
        : null,
      eventsArray,
      isFitersActive: eventsArray.length > 0 || !!periodStart
    };
    dispatch(setFilters(filterOptions))
  }

  const clearFilters = () => {
    setSelectedOptions([{ id: null, name: allEventsOption }]);
    setDateRange(START_DATE_RANGE);
    dispatch(
      setFilters({
        periodStart: null,
        periodEnd: null,
        eventsArray: [],
        isFitersActive: false
      })
    );
  };

  const [dateRange, setDateRange] = useState(START_DATE_RANGE)

  return (
    <>
      <section>
        <div className="bg-secondary p-3 p-lg-4 rounded-1">
          <Col>
            <div className="d-flex justify-content-between align-items-start mb-3">
              <h4 className="position-relative me-3 mb-0">
                {t('meTicketFilters.filters')}
                {isFitersActive && (
                  <div
                    className="position-absolute rounded-circle bg-primary-me-ticket top-0"
                    style={{ width: 10, height: 10, right: -13 }}
                  />
                )}
              </h4>
              <div className="d-flex align-items-center flex-wrap justify-content-end gap-2">
                <ExportReport
                  handleShowLoader={handleShowLoader}
                  isFitersActive={isFitersActive}
                  isLoading={isLoadingStats}
                />
                {isFitersActive && (
                  <div
                    className="text-dark d-flex align-items-center text-nowrap filter-action"
                    style={{ cursor: 'pointer' }}
                    onClick={clearFilters}
                  >
                    <BsXCircle className="me-2" />
                    {t('filters.clear')}
                  </div>
                )}
              </div>
            </div>
            <Row>
              <Col xs={12} lg={5} className="col-lg-5 col-12 mb-xl-0 mb-3">
                <EventSelector
                  events={events}
                  eventMeta={eventMeta}
                  selectedOptions={selectedOptions}
                  setSelectedOptions={setSelectedOptions}
                  allEventsOption={allEventsOption}
                  initialEventId={eventId}
                  onInitialEventResolved={handleInitialEventResolved}
                />
              </Col>
              <Col xs={12} lg={5} className="mb-xl-0 mb-2">
                <DateFilter dateRange={dateRange} setDateRange={setDateRange} />
              </Col>
              <Col lg={2} xs={12}>
                <Button className="w-100 fw-bold py-3" onClick={applyFilters}>
                  {t('filters.applyFilters')}
                </Button>
              </Col>
            </Row>
          </Col>
        </div>
      </section>
    </>
  );
};

export default Filters;
